var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10C17.5978 10.3992 18 11.1454 18 12C18 12.8546 17.5978 13.6008 17 14M18 6C19.7934 7.19765 21 9.43616 21 12C21 14.5638 19.7934 16.8023 18 18M8.83667 6.745V6.745C10.0339 4.9492 10.6325 4.05131 11.1114 3.81378C12.0579 3.34443 13.2061 3.69209 13.7332 4.60759C14 5.07091 14 6.15005 14 8.30832V15.6917C14 17.8499 14 18.9291 13.7332 19.3924C13.2061 20.3079 12.0579 20.6556 11.1114 20.1862C10.6325 19.9487 10.0339 19.0508 8.83667 17.255V17.255C8.60011 16.9002 8.48183 16.7227 8.33865 16.5806C8.06197 16.306 7.71106 16.1181 7.32906 16.0403C7.13138 16 6.91814 16 6.49167 16H5.2C4.0799 16 3.51984 16 3.09202 15.782C2.71569 15.5903 2.40973 15.2843 2.21799 14.908C2 14.4802 2 13.9201 2 12.8V11.2C2 10.0799 2 9.51984 2.21799 9.09202C2.40973 8.71569 2.71569 8.40973 3.09202 8.21799C3.51984 8 4.07989 8 5.2 8H6.49167C6.91814 8 7.13138 8 7.32906 7.95971C7.71106 7.88185 8.06197 7.69405 8.33865 7.41939C8.48183 7.27726 8.60011 7.09984 8.83667 6.745Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume-up.5ca9d69ca1d9eb24179fe98aa0d30404.svg";
export { ForwardRef as ReactComponent };